import { NgModule } from 'ng-metadata/core';
import { FormPhoneModule } from './phone/phone.module';
import { FormAddressModule } from './address/address.module';
import { FormCountryModule } from './country/country.module';
import { FormUsaStateModule } from './usa-state/usa-state.module';
import { FormCreditCardModule } from './credit-card/credit-card.module';
import { FormOrderCancelModule } from './order-cancel/order-cancel.module';

@NgModule({
  imports: [
    FormPhoneModule,
    FormAddressModule,
    FormCountryModule,
    FormUsaStateModule,
    FormCreditCardModule,
    FormOrderCancelModule,
  ],
})
export class FormsModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/forms.module.ts